module.exports = __webpack_public_path__ + "img/success.c1b74d1e.png";